import React, { useEffect, useRef, useState } from 'react';
import { useSpring, animated, config } from 'react-spring';

import Markup from '../../markup';


export const Loader = ({ active, prc, children = <></> }) => {
  const props = useSpring<{ n: number }>({ n: prc })

  return (
    <>
      {active && <>
        <Markup.Global.Loader.Container>
          <Markup.Global.Loader.Item preparing={!prc}>
            <Markup.Global.Loader.Percent>{props.n.interpolate(val => Math.floor(val))}</Markup.Global.Loader.Percent>
            <Markup.Global.Loader.Bar>
              <animated.div style={{ width: props.n.interpolate(val => `${val}%`) }} />
            </Markup.Global.Loader.Bar>
          </Markup.Global.Loader.Item>
        </Markup.Global.Loader.Container>
      </>}
      {children}
    </>
  );
};
